import React from 'react';

export enum AEyebrowVariant {
  Primary = 'primary',
  Secondary = 'secondary',
}

export interface AEyebrowProps extends React.HTMLAttributes<HTMLElement> {
  /** Preferred structured text prop used by AEM and Figma authored data. */
  eyebrowText?: string;
  /** @deprecated Use `eyebrowText` for eyebrow text content. Kept for backwards compatibility. */
  children?: React.ReactNode;
  variant?: AEyebrowVariant;
}
